export default "__VITE_ASSET__s18VyWGW__"